import React from "react"

export default [
	{
		title: "Учёт рабочего времени",
		description:
			"Сразу видишь, отработал&nbsp;ли сотрудник положенное. А&nbsp;зарплата рассчитывается автоматически&nbsp;&mdash; значит, можно сэкономить на&nbsp;рабочих часах бухгалтера.",
	},
	{
		title: "Полная команда",
		description:
			"Не&nbsp;нужно тратиться на&nbsp;отдельную лицензию для каждого сотрудника. Просто подключаешь всех к&nbsp;общему аккаунту заведения.",
	},
	{
		title: "Гибкая система ролей",
		description:
			"Можно создать любое количество должностей и&nbsp;для каждой настроить свои доступы. Даже внутри одной роли могут быть разные права для разных сотрудников.",
	},
]
